<template>
  <div>
    <section>
      <p v-if="isBasketPage" class="font-weight-normal border-bottom">
        {{ $resourceString["basket.Sidebar.Title"] }}
      </p>
      <p v-if="isCheckoutPage" class="font-weight-normal border-bottom">
        {{ $resourceString["checkout.Sidebar.Title"] }}
      </p>
    </section>
    <div v-if="trayItemsCount > 0 || siteItemsCount > 0">
      <p v-if="siteItemsCount" class="font-16 font-weight-bold text-uppercase">
        {{ $resourceString["basket.Sidebar.Samplequantity"] }}:
        {{ siteItemsCount }}
      </p>
      <p v-if="trayItemsCount" class="font-16 font-weight-bold text-uppercase">
        {{ $resourceString["basket.Sidebar.trayquantity"] }} :
        {{ trayItemsCount }}
      </p>
      <div v-if="isBasketPage">
        <div id="WebsiteCheckoutContainer" v-if="checkOutType.isSameAddress">
          <button
            :disabled="quantityValidation || sampleSizeValidation"
            type="button"
            @click="checkOut('Mixed')"
            class="btn btn-primary checkout-btn"
          >
            {{ $resourceString["basket.Sidebar.Checkout"] }}
            <span class="png-icon png-icon-icons-glyph--ko-arrow-next"></span>
          </button>
        </div>
        <div
          v-else-if="
            !checkOutType.isSameAddress &&
              (trayItemsCount == 0 || siteItemsCount == 0)
          "
        >
          <button
            :disabled="quantityValidation || sampleSizeValidation"
            type="button"
            @click="checkOut(trayItemsCount > 0 ? 'Tray' : 'Site')"
            class="btn btn-primary checkout-btn"
          >
            {{ $resourceString["basket.Sidebar.Checkout"] }}
            <span class="png-icon png-icon-icons-glyph--ko-arrow-next"></span>
          </button>
        </div>
      </div>

      <div v-if="isCheckoutPage" class="row">
        <div class="col-12">
          <button
            onclick="location.href='./basket'"
            type="button"
            class="call-to-action-button btn btn-white border-dark w-100 justify-content-center"
          >
            <span
              class="png-icon png-icon-icons-glyph--k-arrow-back position-static"
            >
            </span>
            {{ $resourceString["checkout.BackToBasket"] }}
          </button>
        </div>
        <div class="col-12">
          <button
            type="button"
            :disabled="OrderSampleEnabled"
            @click="checkoutSubmitBtn"
            class="btn btn-primary call-to-action-button w-100 justify-content-center"
          >
            {{ $resourceString["checkout.Sidebar.Submit"] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BEGIN_CHECKOUT_EVENT_NAME } from "../../../constants/gtm-constants";

export default {
  data() {
    return {
      GTMEventName: BEGIN_CHECKOUT_EVENT_NAME,
    };
  },
  props: [
    "isCheckoutPage",
    "isBasketPage",
    "siteItemsCount",
    "trayItemsCount",
    "createStudio"
  ],
  created() {
    this.isOrderSampleEnabled();
  },
  computed: {
    ...mapGetters({
      basketCount: "basketPage/getBasketCount",
      checkOutType: "basketPage/getCheckOutType",
      quantityValidation: "basketPage/getQuantityValidation",
      sampleSizeValidation: "basketPage/getSampleSizeValidation",
      showroomCodeName: "checkoutPage/showroomCodeName",
      vehicleMake: "checkoutPage/vehicleMake",
      vehicleModel: "checkoutPage/vehicleModel",
      vehicleColor: "checkoutPage/vehicleColor",
      deliveryMethod: "checkoutPage/deliveryMethod",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
      basketItems: "basketPage/getBasketItems",
    })
  },
  methods: {
    ...mapActions({
      checkOutPost: "basketPage/checkOutPost",
      checkoutSubmit: "checkoutPage/checkoutSubmit",
      setVehicleMake: "checkoutPage/setVehicleMake",
      setVehicleModel: "checkoutPage/setVehicleModel",
      setVehicleColor: "checkoutPage/setVehicleColor",
      setShowroomCodeName: "checkoutPage/setShowroomCodeName",
      setDeliveryMethod: "checkoutPage/setDeliveryMethod",
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled"
    }),
    checkOut(type) {
      let data = {
        checkoutType: type
      };
      this.$gtm.viewCartEvent(this.basketItems.SiteItems,this.GTMEventName);
      this.checkOutPost(data);
    },
    checkoutSubmitBtn() {
      this.setVehicleMake(this.createStudio.vehicleMake);
      this.setVehicleModel(this.createStudio.vehicleModel);
      this.setVehicleColor(this.createStudio.vehicleColor);
      this.setShowroomCodeName(this.createStudio.warehouseCode);
      this.setDeliveryMethod(this.createStudio.deliveryMethod);
      this.checkoutSubmit();
    }
  }
};
</script>
